import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@chakra-ui/react';

import { IMessageToolCall } from '../../../../../../api/types';

interface BigQueryToolCallProps {
    toolCall: IMessageToolCall;
}

interface BigQueryToolCallArgs {
    question: string;
}

export const BigQueryToolCall: FC<BigQueryToolCallProps> = ({ toolCall }) => {
    const { t } = useTranslation('translations');
    const parseToolCall = (): BigQueryToolCallArgs | undefined => {
        try {
            return JSON.parse(toolCall.function_args);
        } catch {
            return undefined;
        }
    };
    const parsedToolCall = parseToolCall();
    const question = parsedToolCall?.question || 'N/A';

    return <Text>{t('chat-tab.bigquery-tool', { question })}</Text>;
};
